module.exports = __webpack_public_path__ + "assets/img/6_607_big.54ac39fe.jpg";